import styled from 'styled-components';

const AditivoSection = styled.section`
  max-width: 100%;
  border: 2px solid #d1d1d1;
  border-radius: 8px;
  padding: 32px;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  h4 {
    font-size: 24px;
    text-align: center;
    color: ${(props) => props.color};
    margin: 0;
  }

  p {
    font-size: 16px;
    color: #4d4d4d;
    margin: 32px 0 0 0;
    text-align: center;
    line-height: 28px;
  }
  button {
    margin-top: 32px;
  }

  @media (max-width: 768px) {
    button {
      max-width: 100%;
    }
  }
`;

export { AditivoSection };
